import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Icon } from "@iconify/react";

gsap.registerPlugin(ScrollTrigger);

export default function ProblemThatAimToSolve() {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const cardsRef = useRef([]);
  const [activeImage, setActiveImage] = useState(0);

  const projects = [
    {
      id: 1,
      title: "Technical Issues:",
      subTitle:
        "Many free platforms fail during interviews. Visko HR ensures stable, high-quality video interviews for uninterrupted hiring in Dubai.",
      image:
        "https://api.visko.group/public/assets/img/uploads/ticket-docs/Frame%201707481650%20(5)%20(1).webp",
    },
    {
      id: 2,
      title: "No AI Support:",
      subTitle:
        "Traditional portals rely on manual screening. Visko HR integrates AI across every stage of recruitment.",
      image:
        "https://api.visko.group/public/assets/img/uploads/ticket-docs/Frame%201707481650%20(4)%20(1).webp",
    },
    {
      id: 3,
      title: "Weak Candidate Insights:",
      subTitle:
        "Keyword-based resumes hide real talent. Our AI provides deeper candidate analysis and skill validation.",
      image:
        "https://api.visko.group/public/assets/img/uploads/ticket-docs/Frame%201707481650%20(3)%20(1).webp",
    },
    {
      id: 4,
      title: "Fake Applications:",
      subTitle:
        "Fraudulent profiles waste time and resources. Visko HR verifies candidates to keep hiring secure and reliable.",
      image:
        "https://api.visko.group/public/assets/img/uploads/ticket-docs/Frame%201707481650%20(2)%20(1).webp",
    },
    {
      id: 5,
      title: "No Hiring Analytics:",
      subTitle:
        "Without data, decisions suffer. Visko HR delivers smart reports and real-time hiring insights.",
      image:
        "https://api.visko.group/public/assets/img/uploads/ticket-docs/Frame%201707481650%20(1)%20(1).webp",
    },
    {
      id: 6,
      title: "Hidden Bias:",
      subTitle:
        "Old methods often bring hidden bias. Visko HR promotes inclusive and fair recruitment.",
      image:
        "https://api.visko.group/public/assets/img/uploads/ticket-docs/Frame%201707481650%20(7).webp",
    },
  ];

  // useEffect(() => {
  //   const ctx = gsap.context(() => {
  //     gsap.from(headingRef.current.children, {
  //       y: 50,
  //       opacity: 0,
  //       duration: 1,
  //       stagger: 0.2,
  //       ease: "power3.out",
  //       scrollTrigger: {
  //         trigger: headingRef.current,
  //         start: "top 85%",
  //       },
  //     });

  //     cardsRef.current.forEach((card, i) => {
  //       gsap.from(card, {
  //         opacity: 0,
  //         y: 80,
  //         duration: 0.8,
  //         delay: i * 0.1,
  //         ease: "power3.out",
  //         scrollTrigger: {
  //           trigger: card,
  //           start: "top 85%",
  //           toggleActions: "play none none reverse",
  //         },
  //       });
  //     });
  //   }, sectionRef);

  //   return () => ctx.revert();
  // }, []);


  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        sectionRef.current.querySelectorAll(".animate-text"),
        { opacity: 0, y: 60 },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          stagger: 0.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
      gsap.fromTo(
        cardsRef.current,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 75%",
            toggleActions: "play none none reverse",
          },
        }
      );
    })
    return () => ctx.revert();

  }, []);
  const handleHover = (index) => {
    if (index === activeImage) return;
    gsap.to(".sticky-image", {
      opacity: 0,
      duration: 0.4,
      onComplete: () => {
        setActiveImage(index);
        gsap.to(".sticky-image", {
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
        });
      },
    });
  };


  return (
    <section
      ref={sectionRef}
      className="bg-[#0a0a0a] text-white min-h-screen px-6 md:px-20 md:py-24 py-8 overflow-hidden"
    >
      {/* ===== HEADING SECTION ===== */}
      <div className="relative z-10  mx-auto grid md:grid-cols-3 items-center">
        <div className="col-span-2">
          {/* <button className="bg-white/10 border border-white/20 px-5 py-2 rounded-full text-sm mb-6 hover:bg-white/20 transition-all">
            PROBLEMS THAT AIM TO SOLVE
          </button> */}
          <button animate-text className="bg-white/10 border border-white/20 px-4 sm:px-6 py-2 mb-6 rounded-full text-xs sm:text-sm hover:bg-white/20 transition-all flex items-center">
            <Icon
              icon="material-symbols:lightbulb-2-rounded"
              className="mr-2 text-[#F26A33] drop-shadow-[0_0_8px_#F26A33]"
              width="22"
              height="22"
            />
            {/* PROBLEMS THAT AIM TO SOLVE */}
            OUR UNIQUE SOLUTIONS

          </button>
          <h1
            ref={headingRef}
            className="animate-text text-4xl md:text-7xl font-light leading-snug text-gray-400"
          >
            {/* What we create */}
            Problems Recruiters 

            {" "}
            <span className="text-white font-normal">
              {/* for our */}
              Face and 
              </span>{" "}
            {/* digital marketing customer */}
            How We Solve Them
          </h1>
        </div>

        {/* <div className="animate-text text-center justify-end flex sm:hidden">
          <img
            className="opacity-25 w-48 md:w-64"
            src="https://api.visko.group/public/assets/img/uploads/ticket-docs/Union%20(2).svg"
            alt="decorative"
          />
        </div> */}
        <div className="animate-text hidden sm:flex justify-end">
          <img
            className="opacity-25 w-40 sm:w-48 md:w-64"
            src="https://api.visko.group/public/assets/img/uploads/ticket-docs/Union%20(2).svg"
            alt="decorative"
          />
        </div>
      </div>

      {/* ===== CONTENT SECTION ===== */}
      <div className="grid md:grid-cols-3 gap-16 items-start md:mt-20 mt-10 ">
        {/* LEFT IMAGE (Sticky) */}
        <div className="md:col-span-1 animate-text">
          <div className="sticky top-28">
            <div className="relative w-full aspect-square flex items-center justify-center">
              <img
                key={activeImage}
                src={projects[activeImage].image}
                alt="Active visual"
                className="sticky-image rounded-3xl shadow-2xl w-full object-cover transition-all duration-700 ease-in-out transform hover:scale-105"
              />
            </div>
          </div>
        </div>

        {/* RIGHT SCROLLING CARDS */}
        <div className="animate-text md:col-span-2 flex flex-col gap-12 lg:h-[725px] h-[325px] overflow-y-auto pr-3 hide-scrollbar">
          {projects.map((project, i) => (
            <div
              key={project.id}
              // ref={(el) => (cardsRef.current[i] = el)}
              onMouseEnter={() => handleHover(i)}
              className={`flex justify-between items-start border-b border-gray-800 pb-8 group cursor-pointer transition-all duration-300 ${activeImage === i ? "text-[#FF6600]" : ""
                }`}
            >
              <div>
                <div className="flex items-center gap-3 text-xl md:text-3xl font-light pb-3">
                  <span className="text-[#FF6600] font-semibold">
                    .{project.id}/
                  </span>
                  <span
                    className={`font-bold transition-all duration-300 ${activeImage === i
                      ? "text-[#FF6600]"
                      : "text-white group-hover:text-[#FF6600]"
                      }`}
                  >
                    {project.title}
                  </span>
                </div>
                <p
                  className={`text-base font-medium leading-relaxed transition-all duration-300 ${activeImage === i
                    ? "text-[#FF6600]/80"
                    : "text-[#99A1AF]"
                    }`}
                >
                  {project.subTitle}
                </p>
              </div>

              <Icon
                icon="mdi:arrow-top-right"
                className={`text-3xl transition-all duration-500 ${activeImage === i
                  ? "text-[#FF6600]"
                  : "text-white group-hover:text-[#FF6600]"
                  }`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
